import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  untracked,
  ChangeDetectionStrategy
} from "@angular/core";
import { Router } from "@angular/router";
import { formatNumber, NgClass, NgTemplateOutlet } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { SessionDataService } from "../../../../services/shared/SessionDataService.service";
import { HomeService } from "../../home/home.service";
import { TemplateService } from "../../../../services/shared/TemplateService.service";
import { GlobalEntityData } from "../../home/HomeInterface.type";
import { Options } from "highcharts";
import { GraphControllerComponent } from "../../../../modules/graph-module/graph-controller/graph-controller.component";

/**
 * Card summarizing an entity's devices with device-total, device-type, network and alarm charts.
 * Inputs: `entity`, `global`, and `height`.
 */
@Component({
  selector: "app-home-entity-card",
  imports: [TranslateModule, GraphControllerComponent, NgClass, NgTemplateOutlet],
  templateUrl: "./home-entity-card.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./home-entity-card.component.scss"
})
export class HomeEntityCardComponent implements OnInit, AfterViewInit {
  /***************************************************************************/
  // ANCHOR Variables
  /***************************************************************************/
  elseBlock: TemplateRef<any> | null = this.TemplateService.get("elseBlock");

  @Input() entity: GlobalEntityData;
  @Input() global: boolean;
  @Input() height: number;
  @Output() showEntity = new EventEmitter<GlobalEntityData>();
  @ViewChild("card") card: ElementRef;
  numberFormat = untracked(() => this.SessionDataService.numberFormat());

  // Charts
  deviceTotalsHighchartsOptions: any;
  alarmsCloudHighchartsOptions: Options;
  deviceTypeHighchartsOptions: Options;
  networkHighchartsOptions: Options;
  formatNumber = formatNumber;

  /***************************************************************************/
  // ANCHOR Constructor
  /***************************************************************************/

  constructor(
    public HomeService: HomeService,
    private readonly router: Router,
    public SessionDataService: SessionDataService,
    private readonly TemplateService: TemplateService
  ) {}

  /***************************************************************************/
  // ANCHOR Component initialization
  /***************************************************************************/

  ngOnInit(): void {
    this.setDeviceTotalsHighchartsOptions();
    this.deviceTypeHighchartsOptions = this.HomeService.setDeviceTypesHighchartsOptions();
    this.networkHighchartsOptions = this.HomeService.setDeviceTypesHighchartsOptions();
    this.alarmsCloudHighchartsOptions = this.HomeService.setAlarmsCloudHighchartsOptions();
  }

  /***************************************************************************/
  // ANCHOR After-render execution
  /***************************************************************************/

  ngAfterViewInit(): void {
    if (this.height) this.card.nativeElement.style.setProperty("--entity-card-height", this.height);
  }

  /***************************************************************************/
  // ANCHOR Functions
  /***************************************************************************/

  setDeviceTotalsHighchartsOptions(): void {
    let highchartsOptions = {
      exporting: { enabled: false },
      tooltip: { enabled: false },
      credits: { enabled: false },
      accessibility: { enabled: false },
      title: { text: "" },
      plotOptions: {
        series: {
          dataLabels: {
            enabled: false
          }
        },
        bar: {
          stacking: "percent",
          borderWidth: 0.5,
          borderColor: "black",
          animation: false,
          pointWidth: 20,
          dataLabels: { enabled: false }
        }
      }
    };
    this.deviceTotalsHighchartsOptions = highchartsOptions;
  }

  // Select the entity's virtual agrupation before navigating.
  updateNavigation(entity: GlobalEntityData): void {
    this.SessionDataService.sendAgrupation(entity.virtual);
  }

  goToEntity(entity: GlobalEntityData): void {
    this.updateNavigation(entity);
    this.router.navigate(["principal-agrupacion"]);
  }
}
